import type { GetStaticPropsContext } from 'next'
import Search from '@components/search'
import { createClient } from '@lib/prismicio'
import getGlobalStaticProps from '@lib/get-global-static-props'
import { NextSeo } from 'next-seo'
import { Layout } from '@components/common'
import { AnalyticsPageType } from '@shopify/hydrogen-react'

export async function getStaticProps({
  locale,
  previewData,
}: GetStaticPropsContext<{ pages: string[] }>) {
  const client = createClient({ previewData })
  const globalProps = await getGlobalStaticProps(client, locale)

  return {
    props: {
      ...globalProps,
      analyticsPayload: {
        pageType: AnalyticsPageType.search,
      },
    },
    revalidate: 60 * 60, // Every hour
  }
}

const SearchPage = () => {
  return (
    <>
      <NextSeo
        noindex
        canonical={`https://${process.env.NEXT_PUBLIC_SITE_DOMAIN}/search`}
      />
      <Search />
    </>
  )
}

SearchPage.Layout = Layout

export default SearchPage
